/*
  Daryada — fiche produit.
  - Choix d'une finition ou d'une taille : Shopify recalcule lui-même le prix
    et le bouton (rendu de section), le thème ne fait que les remplacer.
  - Galerie en carrousel : une photo à la fois, au doigt, aux flèches ou
    par les vignettes ; jamais de défilement automatique. Un clic ouvre la
    visionneuse plein écran (visionneuse.js).
  Le panier et le paiement restent entièrement gérés par Shopify.
*/
(() => {
  const initProduct = (root) => {
    if (root.dataset.productReady) return;
    root.dataset.productReady = 'true';

    const form = root.querySelector('[data-product-form]');
    const variantsData = (root.closest('.shopify-section') || document).querySelector('[data-variants]');
    const variants = variantsData ? JSON.parse(variantsData.textContent) : [];
    const sectionId = root.dataset.sectionId;

    /* Galerie ------------------------------------------------------- */
    const gallery = root.querySelector('[data-galerie]');
    const slides = gallery ? [...gallery.children] : [];
    const counter = root.querySelector('[data-compteur-actuel]');
    const prev = root.querySelector('[data-galerie-precedent]');
    const next = root.querySelector('[data-galerie-suivant]');
    const strip = root.querySelector('[data-vignettes]');
    const thumbs = [...root.querySelectorAll('[data-galerie-aller]')];
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let current = 0;

    const goTo = (index) => {
      if (!gallery || slides.length < 2) return;
      const target = Math.max(0, Math.min(slides.length - 1, index));
      gallery.scrollTo({
        left: target * gallery.clientWidth,
        behavior: reduceMotion.matches ? 'auto' : 'smooth',
      });
    };

    const setCurrent = (index) => {
      if (index === current) return;
      current = index;
      if (counter) counter.textContent = String(index + 1);
      thumbs.forEach((thumb, i) => {
        if (i === index) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });

      // Une flèche qui s'efface ne doit pas emporter le focus clavier avec elle
      const atStart = index === 0;
      const atEnd = index === slides.length - 1;
      if (prev && next) {
        if (atStart && document.activeElement === prev) next.focus();
        if (atEnd && document.activeElement === next) prev.focus();
        prev.disabled = atStart;
        next.disabled = atEnd;
      }

      // Une vidéo quittée s'arrête
      slides.forEach((slide, i) => {
        if (i !== index) slide.querySelectorAll('video').forEach((video) => video.pause());
      });

      // Bureau : garde la vignette active visible dans la colonne
      const thumb = thumbs[index];
      if (strip && thumb && strip.scrollHeight > strip.clientHeight) {
        strip.scrollTo({
          top: thumb.offsetTop - (strip.clientHeight - thumb.offsetHeight) / 2,
          behavior: reduceMotion.matches ? 'auto' : 'smooth',
        });
      }
    };

    if (gallery && slides.length > 1) {
      let ticking = false;
      gallery.addEventListener(
        'scroll',
        () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(() => {
            setCurrent(Math.round(gallery.scrollLeft / gallery.clientWidth));
            ticking = false;
          });
        },
        { passive: true }
      );

      if (prev) prev.addEventListener('click', () => goTo(current - 1));
      if (next) next.addEventListener('click', () => goTo(current + 1));
      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => goTo(Number(thumb.dataset.galerieAller)));
      });

      // Une fenêtre redimensionnée garde la même photo à l'écran
      window.addEventListener('resize', () => {
        gallery.scrollTo({ left: current * gallery.clientWidth, behavior: 'auto' });
      });

      // En quittant la visionneuse, la galerie montre la dernière photo regardée
      root.addEventListener('visionneuse:fermee', (event) => {
        const index = slides.findIndex((slide) => slide.dataset.mediaId === event.detail.mediaId);
        if (index > -1) gallery.scrollTo({ left: index * gallery.clientWidth, behavior: 'auto' });
      });
    }

    /* Variantes ------------------------------------------------------- */
    const onOptionChange = async () => {
      const selected = [...root.querySelectorAll('[data-option-index]')].map(
        (fieldset) => fieldset.querySelector('input:checked')?.value
      );
      const variant = variants.find((v) => v.options.every((value, i) => value === selected[i]));
      const idInput = form.querySelector('[data-variant-id]');
      const button = form.querySelector('[data-add-button]');

      if (!variant) {
        if (button) button.disabled = true;
        return;
      }

      idInput.value = variant.id;
      const url = `${root.dataset.url}?variant=${variant.id}`;
      window.history.replaceState({}, '', url);

      // Prix, bouton et délai recalculés par Shopify, dans la bonne langue et la bonne devise
      try {
        const response = await fetch(`${url}&section_id=${sectionId}`);
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        ['prix', 'achat'].forEach((key) => {
          const fresh = html.querySelector(`[data-maj="${key}"]`);
          const existing = root.querySelector(`[data-maj="${key}"]`);
          if (fresh && existing) existing.replaceWith(fresh);
        });
      } catch (error) {
        // En cas d'échec réseau, le formulaire reste valide : la bonne variante est déjà sélectionnée
      }

      // Affiche la photo de la variante choisie, sans faire bouger la page
      if (variant.featured_media) {
        const index = slides.findIndex((slide) => slide.dataset.mediaId === String(variant.featured_media.id));
        if (index > -1) goTo(index);
      }
    };

    root.querySelectorAll('[data-option]').forEach((input) => {
      input.addEventListener('change', onOptionChange);
    });
  };

  const initAll = () => document.querySelectorAll('[data-produit]').forEach(initProduct);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
